import classNames from 'classnames';
import Image from 'next/image';
import { imageSerializer } from '../../../../utils/imageSerializer';
import { RichTextBlock } from 'prismic-reactjs';
import { ImageFieldImage } from '@prismicio/types';

type Props = {
  invert?: boolean;
  title: string;
  description: string;
  subtitle: string;
  subTitleInfo?: string;
  subDescription: string;
  sectionIndex: number;
  image?: RichTextBlock | ImageFieldImage;
};

export const ParallaxSection = ({
  invert,
  title,
  description,
  subtitle,
  subTitleInfo,
  subDescription,
  sectionIndex,
  image,
}: Props) => {
  const className = classNames(
    'parallax__section',
    invert && 'parallax__section-invert'
  );

  return (
    <section className={className} id={`parallax_${sectionIndex}`}>
      <div className="parallax__section-container">
        <div className="parallax__section-container-left">
          <h2 className="parallax__section-container-left-title">{title}</h2>
          <p className="parallax__section-container-left-description">
            {description}
          </p>
        </div>
        <div className="parallax__section-container-image">
          {image && <Image {...imageSerializer(image, { inset: null })} />}
        </div>
        <div className="parallax__section-container-right">
          <span className="parallax__section-container-right-subtitle-info parallax__section-container-right-subtitle-info--help-you-with">
            {subTitleInfo}
          </span>
          <p className="parallax__section-container-right-subtitle">
            {subtitle}
          </p>
          <p className="parallax__section-container-right-description">
            {subDescription}
          </p>
        </div>
      </div>
    </section>
  );
};
